import { render, staticRenderFns } from "./TermosDeUsoCombobox.vue?vue&type=template&id=2c275f7d&scoped=true"
import script from "./TermosDeUsoCombobox.vue?vue&type=script&lang=js"
export * from "./TermosDeUsoCombobox.vue?vue&type=script&lang=js"
import style0 from "./TermosDeUsoCombobox.vue?vue&type=style&index=0&id=2c275f7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c275f7d",
  null
  
)

export default component.exports